import type { RatingLevel } from "@/services/api/guardiansv2/types";

/** Badge colour tokens for ``RatingBadge`` (matches MC status palette). */
export const RATING_BADGE_COLOR: Record<RatingLevel, "red" | "amber" | "emerald"> = {
  red: "red",
  amber: "amber",
  green: "emerald",
};

export const RATING_LABELS: Record<RatingLevel, string> = {
  red: "Red",
  amber: "Amber",
  green: "Green",
};

export const PERSONA_DOT_CLASS: Record<string, string> = {
  red: "bg-red-500",
  amber: "bg-amber-500",
  green: "bg-emerald-500",
};
